import { Accordion as MUIAccordion } from '@mui/material';
import { useState, SyntheticEvent, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { isEqual } from 'lodash';

import { ProductContext } from '../../../context/Products/context';
import CustomButton from '../../atoms/custom-button/custom-button';
import FilterGroup from '../../organisms/filter-group/filter-group';
import * as S from './styles';

/* eslint-disable-next-line */
type AccordionProps = {
  accordionHeaderColor: string;
  handleClearFilters: () => void;
  handleSelectFilter: (type: string, value: string, status: boolean) => void;
  handleViewCategories?: () => void;
};

export function Accordion(props: AccordionProps) {
  const {
    accordionHeaderColor,
    handleClearFilters,
    handleSelectFilter,
    handleViewCategories
  } = props;

  const [expanded, setExpanded] = useState<string | false>(false);
  const { state } = useContext(ProductContext);

  const handleChange =
    (panel: string) => (event: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const groupAccordion = state.categoryFilters
    .map((categoryFilterGroup: any) => {
      const headerColor = isEqual(expanded, categoryFilterGroup.type)
        ? accordionHeaderColor
        : 'text-black';

      return (
        <MUIAccordion
          expanded={expanded === categoryFilterGroup.type}
          key={categoryFilterGroup.type}
          sx={{ boxShadow: 'none' }}
          onChange={handleChange(categoryFilterGroup.type)}
        >
          <AccordionSummary
            expandIcon={
              isEqual(expanded, categoryFilterGroup.type) ? (
                <FontAwesomeIcon
                  className={`${accordionHeaderColor} cursor-pointer`}
                  height={15}
                  icon={faMinus}
                  width={15}
                />
              ) : (
                <FontAwesomeIcon
                  className="text-black cursor-pointer"
                  height={15}
                  icon={faPlus}
                  width={15}
                />
              )
            }
          >
            <p className={`capitalize ${headerColor}`}>
              {categoryFilterGroup.type}
            </p>
          </AccordionSummary>
          <AccordionDetails>
            <FilterGroup
              filterItems={categoryFilterGroup.options}
              filterTitle={categoryFilterGroup.type}
              key={categoryFilterGroup.type}
              handleSelectFilter={(type, filterValue, status) =>
                handleSelectFilter(type, filterValue, status)
              }
            />
          </AccordionDetails>
        </MUIAccordion>
      );
    })
    .reverse();

  return (
    <>
      <S.Container>{groupAccordion}</S.Container>
      <div className="flex flex-col items-start space-y-4 mt-4">
        <button
          onClick={handleClearFilters}
          className={`font-MuseoSans100 text-subtitle hover:underline hover:${accordionHeaderColor} underline`}
        >
          Clear Filters
        </button>
        <CustomButton
          buttonText="VIEW OTHER CATEGORIES"
          buttonStyle="bg-primaryGray text-white hover:text-black hover:bg-widgetGray mt-8"
          textStyle="border-white group-hover:border-primaryGray"
          handleClickButton={handleViewCategories}
        />
      </div>
    </>
  );
}

export default Accordion;
